<template>
  <section class="sort-list">
    <b-dropdown
      no-caret
      class="header-app__navbar-button-lang_navbar"
      menu-class="header-app__navbar-button-lang_menu"
      toggle-class="events-aside__sort-list_toggle"
      type="button"
    >
      <template v-slot:button-content>
        <span class="sort-list__filter">
        {{ filterCondition.text }}
          <font-awesome-icon icon="chevron-down" class="chevron-icon"/>
        </span>
      </template>
      <b-dropdown-item
        v-for="(condition, index) of filterVariants"
        :key="index"
        link-class="sort-list__dropdown-item"
        @click="$emit('filterBy', condition)"
        href="#"
      >
        {{ condition.text }}
      </b-dropdown-item>
    </b-dropdown>
    <b-dropdown
      no-caret
      class="header-app__navbar-button-lang_navbar"
      menu-class="header-app__navbar-button-lang_menu"
      toggle-class="events-aside__sort-list_toggle"
      type="button"
    >
      <template v-slot:button-content>
        <span class="sort-list__filter">
        {{ sortCondition.text }}<font-awesome-icon icon="chevron-down" class="chevron-icon"/>
        </span>
      </template>
      <b-dropdown-item
        v-for="(condition, index) of sortVariants"
        :key="index"
        link-class="sort-list__dropdown-item"
        @click="$emit('sortBy', condition)"
        href="#"
      >
        {{ condition.text }}
      </b-dropdown-item>
    </b-dropdown>
  </section>
</template>

<script>
export default {
  name: 'SortList',
  props: {
    sortCondition: {
      type: Object,
      default: () => ({}),
    },
    sortVariants: {
      type: Array,
      default: () => [],
    },
    filterCondition: {
      type: Object,
      default: () => ({}),
    },
    filterVariants: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style>
.sort-list {
    margin-top: 16px;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    align-items: center;
    color: var(--btn-primary);
  }

  .chevron-icon {
    color: var(--btn-primary) !important;
  }
  .sort-list__dropdown-item {
    font-size: .8rem;
    display: flex;
    align-items: center;
  }
  .sort-list__dropdown-item,
  .sort-list__dropdown-item:hover,
  .sort-list__dropdown-item:active,
  .sort-list__dropdown-item:focus {
    height: 35px;
    color: var(--text-main-color);
    background: #FFFFFF;
  }

  .sort-list__dropdown-item:hover {
    background: #F3F6FD !important;
  }

  .sort-list__dropdown-item_lang,
  .sort-list__dropdown-item_lang:hover,
  .sort-list__dropdown-item_lang:focus {
    color: var(--text-main-color);
    background: #FFFFFF;
  }

  .sort-list__dropdown-item_lang:active,
  .sort-list__dropdown-item_lang.active {
    color: var(--text-main-color);
    background: #F3F6FD !important;
  }
</style>
